<script>
import Layout from "@layouts/auth";
import appConfig from "@src/app.config";
import config from "@configs/msal.json";
import { PublicClientApplication } from "@azure/msal-browser";
import urlLogoLightAvila from "@assets/images/logo-light.png";
import urlLogoLightAgeradora from "@assets/images/Ageradora/logo.png";
import urlLogoLightAvantia from "@assets/images/Avantia/logo.png";
import urlLogoLightFps from "@assets/images/Fps/logo.png";
import urlLogoSisloc from "@assets/images/Sisloc/LogoSisloc.png";
import router from "@router";

export default {
  page: {
    title: "Log in",
    meta: [
      {
        name: "description",
        content: `Log in to ${appConfig.title}`
      }
    ]
  },
  components: {
    Layout
  },
  data: function() {
    return {
      appConfig: appConfig,
      email: "",
      password: "",
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      loginConfig: { logo: {} },
      const64: "data:image/png;base64,",
      msalInstance: {},
      tokenMASL: {},
      src: null,
      logoLightAvila: urlLogoLightAvila,
      logoLightAgeradora: urlLogoLightAgeradora,
      logoLightAvantia: urlLogoLightAvantia,
      logoLightFps: urlLogoLightFps,
      logoSisloc: urlLogoSisloc
    };
  },
  computed: {
    loggingIn() {
      return this.$store.state.auth.status.loggingIn;
    },
    alert() {
      return this.$store.state.alert;
    },
    logo() {
      return "data:image/png;base64," + this.loginConfig.logo;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },
  async created() {
    this.msalInstance = new PublicClientApplication(config);
    this.$store.dispatch("alert/clear");
    this.$store.dispatch("filter/clear");
  },
  mounted() {
    this.selectLogo();
    if (this.msalInstance.getAllAccounts() > 0) {
      this.SignIn();
    }
  },
  methods: {
    async SignIn() {
      const self = this;
      await this.msalInstance.loginPopup({}).then(() => {
        const myAccounts = this.msalInstance.getAllAccounts();
        const accessTokenRequest = {
          scopes: ["profile"],
          account: myAccounts[0]
        };
        this.msalInstance
          .acquireTokenSilent(accessTokenRequest)
          .then(function(accessTokenResponse) {
            self.$store.dispatch("auth/token", {
              token: accessTokenResponse.idToken,
              expires: accessTokenResponse.expiresOn
            });
          })
          .catch(function(error) {
            console.log(error);
          });
      });
    },
    tryToLogIn() {
      this.submitted = true;
      const { email, password } = this;
      if (email && password) {
        this.$store.dispatch("auth/login", {
          email,
          password
        });
        this.$store.dispatch("alert/clear");
      }
    },
    azuread() {
      this.SignIn();
    },
    closeAlert() {
      this.$store.dispatch("alert/clear");
    },
    selectLogo() {
      let caminho = window.location.search.toLowerCase();

      if (caminho == "?q=avantia") {
        localStorage.setItem("cliente", "Avantia");
        this.src = this.logoLightAvantia;
      } else if (caminho == "?q=ageradora") {
        localStorage.setItem("cliente", "Ageradora");
        this.src = this.logoLightAgeradora;
      } else if (caminho == "?q=fps") {
        localStorage.setItem("cliente", "Fps");
        this.src = this.logoLightFps;
      } else if (caminho == "?q=sisloc") {
        localStorage.setItem("cliente", "Sisloc");
        this.src = this.logoSisloc;
      } else {
        localStorage.setItem("cliente", "");
        this.src = this.logoLightAvila;
        router.push("/Login");
      }
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-6 col-xl-5">
        <div class="card cardlogin">
          <div class="card-body p-4">
            <div class="text-center w-75 m-auto">
              <div class="loginCircle">
                <img
                  src="@assets/images/userLogin.png"
                  class="logoUser"
                  alt=""
                />
              </div>

              <p class="text-muted mb-3 bemvindo" style="color:#339B78;">
                Bem-vindo ao Hub Indicador
              </p>

              <img
                @click="azuread"
                src="@assets/images/microsoft.png"
                class="microImg"
              />
              <a href="/">
                <span
                  ><img :src="src" class="logo m-auto" alt="" height="70"
                /></span>
              </a>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss">
.bemvindo {
  color: #339b78 !important;
  font-size: 22px;
  opacity: 0.7;
}
.cardlogin {
  box-shadow: 0px 3px 35px 3px #d0ede3;
}
.logoUser {
  height: 50px;
  border-radius: 50%;
  background-color: #cee0da;
}
.microImg {
  width: 300px;
  height: 45px;
  margin-bottom: 40px;
}
.loginCircle {
  height: 80px;
  width: 80px;
  position: relative;
  top: -80px;
  left: 105px;
  padding-top: 15px;
  background-color: #cee0da;
  border-radius: 50%;
  margin-bottom: 0px;
}
body {
  background-image: url("~@assets/images/backgroundLogin.png");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}
@media (max-width: 890px) {
  .loginCircle {
    height: 80px;
    width: 80px;
    position: relative;
    top: -80px;
    left: 40%;
    padding-top: 15px;
    background-color: #cee0da;
    border-radius: 50%;
    margin-bottom: 0px;
  }
  .microImg {
    width: 100%;
    height: 6vh;
  }
}
</style>
